import axios from "axios";
import { getBackendUrl } from "@/general";


export const dataGridNominasElectronicas = async (context, page, search) => {
  const parameters = {
    "page": page,
    "search": search
  }

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/movimientos/api/dataGridNominaElectronica/`,
      {
        params: parameters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const importFileElectronicPayroll = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/movimientos/api/enviarNominaElectronica`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.error(err);
    throw err.response;
  }
}
